<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="4000"
      controls
      indicators
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333;"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      <b-carousel-slide v-for="(item,index) in imgs" :key="index" :img-src="item"></b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Banner",
  data() {
    return {
      src1: [],
      src2: [],
      src3: [],
      imgs: this.files1,
      slide: 0,
      sliding: null,
      screenWidth: document.documentElement.clientWidth
    };
  },
  created() {
    this.gainSrc();
    let that = this;
    that.screenWidth = document.documentElement.clientWidth;
    if (that.screenWidth > 900) {
      that.imgs = that.files1;
    } else if (that.screenWidth > 600) {
      that.imgs = that.files2;
    } else {
      that.imgs = that.files3;
    }
    window.onresize = () => {
      return (() => {
        that.screenWidth = document.documentElement.clientWidth;
        if (that.screenWidth > 900) {
          that.imgs = that.files1;
        } else if (that.screenWidth > 600) {
          that.imgs = that.files2;
        } else {
          that.imgs = that.files3;
        }
      })();
    };
  },
  computed: {
    files1() {
      var container = [];
      for (let item of this.src1) {
        container.push(require("./images/maxImages" + item));
      }
      return container;
    },
    files2() {
      var container = [];
      for (let item of this.src2) {
        container.push(require("./images/largeImages" + item));
      }
      return container;
    },
    files3() {
      var container = [];
      for (let item of this.src3) {
        container.push(require("./images/minImages" + item));
      }
      return container;
    }
  },
  updated() {
    this.screenWidth = document.documentElement.clientWidth;
    if (this.screenWidth > 992) {
      this.imgs = this.files1;
    } else if (this.screenWidth > 472) {
      this.imgs = this.files2;
    } else {
      this.imgs = this.files3;
    }
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    gainSrc() {
      var files = require
        .context("./images/maxImages", false, /.(png|jpg|jpeg|gif|bmp|webp)$/)
        .keys();
      this.src1 = files.map(item => item.replace(".", ""));
      files = require
        .context("./images/largeImages", false, /.(png|jpg|jpeg|gif|bmp|webp)$/)
        .keys();
      this.src2 = files.map(item => item.replace(".", ""));
      files = require
        .context("./images/minImages", false, /.(png|jpg|jpeg|gif|bmp|webp)$/)
        .keys();
      this.src3 = files.map(item => item.replace(".", ""));
    }
  }
};
</script>

<style scoped>
span .carousel-control-next-icon {
  width: 12.5rem;
  height: 12.5rem;
}

.banner-div {
  background-image: url(./images/banner-12.jpg);
}
@media screen and (max-width: 992px) {
  .banner-div {
    background-image: url(./images/banner-11.jpg);
  }
}
@media screen and (min-width: 472px) {
  .banner-div {
    background-image: url(./images/banner-13.jpg);
  }
}
</style>
